import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export const RootRedirect: React.FC = () => {
  const { user, loading } = useAuth()

  useEffect(() => {
    // If user is not authenticated, redirect to the main marketing site
    if (!loading && !user) {
      window.location.href = 'https://syncsimple.ai/'
    }
  }, [user, loading])

  // Show loading while authentication is being checked
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
          <p className="mt-2 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  // If user is authenticated, redirect to dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />
  }

  // Fallback - this shouldn't be reached due to the useEffect above
  return null
} 